import React from 'react';
import { Col, Row } from 'react-bootstrap';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import UserList from './UserList';
import PayrollWidget from './PayrollWidget';
import ActionCenterWidget from './ActionCenterWidget';
import UKComplianceOverview from './UkComplianceOverview';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DirectoryService from '../directory/DirectoryService';

const PayrollLandingPage = () => {
  const [employees, setEmployees] = useState([]);
  const [error, setError] = useState('');
  const [totalNationalInsurance, setTotalNationalInsurance] = useState(0.0);
  const [totalPayroll, setTotalPayroll] = useState(0.0);
  const [showDashboard, setShowDashboard] = useState(false);
  const navigate = useNavigate();
  const calculateNIC = salary => {
    if (salary <= 0) {
      return 0;
    }
    const nicRate = 0.138; // 2025/26 NIC rate
    const firstThreshold = 758; // First threshold for NIC

    return (salary - firstThreshold) * nicRate;
  };
  const calculatePayroll = salary => {
    if (salary <= 0) {
      return 0;
    }
    return salary + calculateNIC(salary);
  };
  useEffect(() => {
    console.log(error);
    DirectoryService.retrieveUsersByAccount()
      .then(data => {
        setEmployees(data);
        const totalPayroll = employees.reduce((sum, emp) => {
          const salary = emp.contract?.grossSalary || 0;
          sum += calculatePayroll(salary);
          return sum;
        }, 0);

        setTotalPayroll(totalPayroll.toFixed(2));

        // Calculate total National Insurance contributions
        const totalNIC = employees.reduce((sum, emp) => {
          const salary = emp.contract?.grossSalary || 0;
          sum += calculateNIC(salary);
          return sum;
        }, 0);
        setTotalNationalInsurance(totalNIC.toFixed(2));
        setShowDashboard(true);
      })
      .catch(error => {
        setError(error.message);
      });
  }, [totalPayroll, totalNationalInsurance]);
  const buttonsConf = [
    {
      name: 'Export Payroll',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Create a new Job Vacancy');
        navigate('/app/roles/role-form');
      }
    },
    {
      name: 'Run Payroll',
      type: 'button',
      variant: 'info',
      onClick: () => {
        navigate('/app/roles/salarylevels');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
    'Payroll',
    'Manage your payroll efficiently with our comprehensive Payroll module. Streamline salary calculations, tax deductions, and employee payments all in one place. Our user-friendly interface allows you to easily track payroll history, generate reports, and ensure compliance with tax regulations. Simplify your payroll process and focus on what matters most - your employees.',
    buttonsConf
  );
  return (
    <>
      {headerGenerated}

      {showDashboard && (
        <Row className="g-3 mb-3">
          <Col xxl={3} lg={12}>
            <PayrollWidget
              icon={'fa-pound-sign'}
              iconBackground={'#3B82F6'}
              title={'Total Payroll'}
              amount={'£' + totalPayroll}
            />
          </Col>
          <Col xxl={3} lg={12}>
            {employees && (
              <PayrollWidget
                icon={'fa-users'}
                iconBackground={'#23C55F'}
                title={'Employees'}
                amount={employees.length}
                link={'/social/directory/user-list'}
              />
            )}
          </Col>
          <Col xxl={3} lg={12}>
            <PayrollWidget
              icon={'fa-file-invoice-dollar'}
              iconBackground={'#EBB30B'}
              title={'Tax Deductions'}
              amount={'£0'}
            />
          </Col>
          <Col xxl={3} lg={12}>
            <PayrollWidget
              iconBackground={'#A855F7'}
              title={'National Insurance'}
              amount={'£' + totalNationalInsurance}
            />
          </Col>
        </Row>
      )}
      <Row className="g-3">
        <Col xxl={4}>
          <ActionCenterWidget />
        </Col>
        <Col xxl={8}>
          <UKComplianceOverview />
        </Col>
      </Row>
      <Row className="g-3">
        <Col xxl={12} style={{ paddingTop: '10px' }}>
          <UserList></UserList>
        </Col>
        <Col xxl={4}></Col>
      </Row>
    </>
  );
};

export default PayrollLandingPage;
